import { render, staticRenderFns } from "./NakesEdit.vue?vue&type=template&id=a2e483e0&scoped=true"
import script from "./NakesEdit.vue?vue&type=script&lang=js"
export * from "./NakesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e483e0",
  null
  
)

export default component.exports